import imageCompression from 'browser-image-compression';

// Optionen für die Bildkomprimierung
const compressionOptions = {
  maxSizeMB: 1, // Maximale Dateigröße in MB
  maxWidthOrHeight: 1200, // Maximale Breite oder Höhe in Pixeln
  useWebWorker: true, // Verwende Web Worker für bessere Performance
  fileType: 'image/jpeg', // Ziel-Dateityp
  initialQuality: 0.8, // Anfangsqualität (0.1 - 1.0)
  preserveExif: true, // WICHTIG: EXIF-Daten (inkl. Orientierung) beibehalten
};

/**
 * Komprimiert ein Bild-File
 * @param {File} file - Das zu komprimierende Bild-File
 * @returns {Promise<File>} - Das komprimierte Bild-File
 */
export const compressImage = async (file) => {
  try {
    // Prüfen, ob es sich um ein Bild handelt
    if (!file || !file.type.startsWith('image/')) {
      throw new Error('Das ausgewählte File ist kein Bild');
    }

    console.log('Original Dateigröße:', (file.size / 1024 / 1024).toFixed(2), 'MB');
    
    const compressedFile = await imageCompression(file, compressionOptions);
    
    console.log('Komprimierte Dateigröße:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB');
    console.log('Komprimierung:', ((1 - compressedFile.size / file.size) * 100).toFixed(1), '% Reduktion');
    
    return compressedFile;
  } catch (error) {
    console.error('Fehler bei der Bildkomprimierung:', error);
    throw error;
  }
};

/**
 * Komprimiert ein Bild mit benutzerdefinierten Optionen
 * @param {File} file - Das zu komprimierende Bild-File
 * @param {Object} customOptions - Benutzerdefinierte Komprimierungsoptionen
 * @returns {Promise<File>} - Das komprimierte Bild-File
 */
export const compressImageWithOptions = async (file, customOptions = {}) => {
  const options = { ...compressionOptions, ...customOptions };
  
  try {
    console.log('Original Dateigröße:', (file.size / 1024 / 1024).toFixed(2), 'MB');
    
    const compressedFile = await imageCompression(file, options);
    
    console.log('Komprimierte Dateigröße:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB');
    
    return compressedFile;
  } catch (error) {
    console.error('Fehler bei der Bildkomprimierung:', error);
    throw error;
  }
}; 